// Version : 1.0.0
// Author : AGALYA

const HouseDetailsActionType = {
	/** ***************** update House Details Start ************************/
	HOUSE_DETAILS_CREATE_START: 'house_details_create_start',
	HOUSE_DETAILS_CREATE_SUCCESS: 'house_details_create_success',
	HOUSE_DETAILS_CREATE_FAILURE: 'house_details_create_failure',
	HOUSE_DETAILS_CREATE_RESPONSE_REST_START: 'house_details_create_response_reset_start',
	HOUSE_DETAILS_CREATE_RESPONSE_CHANGED: 'house_details_create_response_changed',
	/** ***************** update House Details End ************************/
};

export default HouseDetailsActionType;
